// First-booking install nudge helper.
// Goal: drive PWA adoption (and therefore push-notification opt-ins) by
// routing brand-new customers through /install on their first successful
// booking. Returning customers and customers already running the PWA skip
// the detour and go straight to /track/{id}.

const FLAG_KEY = "link_has_booked_before";

function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

/**
 * Decide where to send the customer right after a successful booking, then
 * persist the "I've booked before" flag so we never redirect them twice.
 *
 *   navigate: react-router-dom navigate()
 *   bookingId: the booking just created / paid for
 */
export function navigateAfterFirstBooking(navigate, bookingId) {
  const trackPath = `/track/${bookingId}`;
  let isFirst = false;
  try {
    isFirst = !localStorage.getItem(FLAG_KEY);
  } catch (_) {
    // localStorage blocked (private mode, etc.) — treat as returning so we
    // don't annoy users in restrictive contexts.
    isFirst = false;
  }
  try {
    localStorage.setItem(FLAG_KEY, String(Date.now()));
  } catch (_) {
    /* ignore */
  }
  if (isFirst && !isStandalone()) {
    navigate(`/install?next=${encodeURIComponent(trackPath)}&first=1`);
  } else {
    navigate(trackPath);
  }
}
